import { StandardQuizQuestion } from '@/types/quizTypes';

export const K8S_NETWORKING_QUIZ: StandardQuizQuestion[] = [
  {
    id: "k8s-net-1",
    question: "What is a Kubernetes Service?",
    options: [
      "A running container",
      "An abstraction that provides stable networking for pods",
      "A storage volume",
      "A configuration file"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "A Service provides a stable IP address and DNS name for a set of pods, enabling reliable communication even as pods are created and destroyed.",
    category: "services",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "k8s-net-2",
    question: "What type of Service exposes pods to external traffic?",
    options: [
      "ClusterIP",
      "LoadBalancer",
      "Headless",
      "ExternalName"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "LoadBalancer Service creates an external load balancer (in supported cloud environments) that routes external traffic to pods. NodePort also exposes externally but on node IPs.",
    category: "services",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "k8s-net-3",
    question: "What is the default Service type in Kubernetes?",
    options: [
      "NodePort",
      "ClusterIP",
      "LoadBalancer",
      "Ingress"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "ClusterIP is the default Service type, providing an internal IP accessible only within the cluster. It's used for internal pod-to-pod communication.",
    category: "services",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "k8s-net-4",
    question: "What is an Ingress in Kubernetes?",
    options: [
      "A type of pod",
      "An API object that manages external HTTP/HTTPS access to services",
      "A storage class",
      "A node label"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Ingress manages external HTTP/HTTPS access to services, providing load balancing, SSL termination, and name-based virtual hosting. Requires an Ingress Controller.",
    category: "ingress",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "k8s-net-5",
    question: "What networking rule does Kubernetes enforce for pod communication?",
    options: [
      "Pods must use proxy servers",
      "All pods can communicate with each other without NAT",
      "Pods can only talk to their node",
      "Pods need VPN connections"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Kubernetes requires a flat network where all pods can communicate directly with each other without NAT, regardless of which node they're on. This is implemented by CNI plugins.",
    category: "networking-model",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "k8s-net-6",
    question: "What is a NetworkPolicy used for?",
    options: [
      "Defining DNS settings",
      "Controlling network traffic between pods",
      "Setting bandwidth limits",
      "Configuring load balancers"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "NetworkPolicies are firewall rules that control ingress and egress traffic for pods based on labels, namespaces, and ports. Requires a CNI plugin that supports NetworkPolicy.",
    category: "network-policy",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "k8s-net-7",
    question: "What is the purpose of DNS in Kubernetes?",
    options: [
      "Pod scheduling",
      "Service discovery via DNS names",
      "Storage management",
      "Image pulling"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Kubernetes DNS (CoreDNS) enables service discovery by automatically creating DNS records for services and pods, allowing name-based communication instead of IP addresses.",
    category: "dns",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "k8s-net-8",
    question: "What is a headless Service in Kubernetes?",
    options: [
      "A Service without containers",
      "A Service with ClusterIP set to None for direct pod access",
      "A Service without endpoints",
      "A Service that doesn't route traffic"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Headless Services (ClusterIP: None) don't provide load balancing or a single Service IP. Instead, DNS returns the pod IPs directly, useful for stateful applications.",
    category: "services",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateK8sNetworkingQuiz = () => ({
  questions: K8S_NETWORKING_QUIZ,
  passThreshold: 80,
  timeLimit: 900,
  category: 'kubernetes-networking'
});
